export default __webpack_public_path__ + "static/media/smsProvider.c8bfab95.svg";